<!-- Page Header -->
<div class="page-header">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Envío Masivo SRI</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Transacciones</span>
    </div>
  </div>
</div>

<!-- Tarjetas de totales -->
<div class="row row-sm mb-1">
  <div class="col-sm-6 col-lg-4">
    <div class="card stat-card stat-card--warning">
      <div class="card-body d-flex align-items-center">
        <div class="stat-icon"><i class="fe fe-file-text"></i></div>
        <div class="ms-3">
          <span class="stat-label">Facturas pendientes por enviar</span>
          <h3 class="stat-value mb-0">{{ totalFacturas | number }}</h3>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-6 col-lg-4">
    <div class="card stat-card stat-card--success">
      <div class="card-body d-flex align-items-center">
        <div class="stat-icon"><i class="fe fe-dollar-sign"></i></div>
        <div class="ms-3">
          <span class="stat-label">Valor total pendiente</span>
          <h3 class="stat-value mb-0">$ {{ totalSaldo | number: '1.2-2' }}</h3>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-lg-4">
    <div class="card stat-card stat-card--primary">
      <div class="card-body d-flex align-items-center">
        <div class="stat-icon"><i class="fe fe-calendar"></i></div>
        <div class="ms-3">
          <span class="stat-label">Días con pendientes</span>
          <h3 class="stat-value mb-0">{{ resumen.length | number }}</h3>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Panel de filtros -->
<div class="row row-sm mb-3">
  <div class="col-12">
    <div class="card control-panel-card">
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-12 col-xl-auto">
            <h6 class="control-section-title mb-2">Rango de fechas</h6>
          </div>
          <div class="col-6 col-md-3 col-xl-2">
            <label class="form-label">Desde</label>
            <input type="date" class="form-control" [(ngModel)]="fechaInicio" [disabled]="cargando">
          </div>
          <div class="col-6 col-md-2 col-xl-2">
            <label class="form-label">Hora</label>
            <input type="time" class="form-control" [(ngModel)]="horaInicial" [disabled]="cargando">
          </div>
          <div class="col-6 col-md-3 col-xl-2">
            <label class="form-label">Hasta</label>
            <input type="date" class="form-control" [(ngModel)]="fechaFin" [disabled]="cargando">
          </div>
          <div class="col-6 col-md-2 col-xl-2">
            <label class="form-label">Hora</label>
            <input type="time" class="form-control" [(ngModel)]="horaFinal" [disabled]="cargando">
          </div>
          <div class="col-12 col-md-2 col-xl-2">
            <button class="btn btn-primary w-100" (click)="buscarResumen()" [disabled]="cargando">
              <i class="fe fe-search me-1"></i> {{ cargando ? 'Buscando...' : 'Buscar' }}
            </button>
          </div>
        </div>

        <div class="info-banner mt-3" role="note">
          <div class="info-banner__icon"><i class="fe fe-info"></i></div>
          <div class="info-banner__text">
            Haga clic en una fecha para ver y enviar al SRI las facturas pendientes de ese día.
            Solo se procesan comprobantes <strong>electrónicos</strong> (máx. 250 por proceso).
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Tabla resumen por fechas -->
<div class="row row-sm">
  <div class="col-12">
    <div class="card">
      <div class="card-header border-bottom">
        <h6 class="card-title mb-0 text-uppercase fw-bold">Facturas pendientes por fechas</h6>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                 class="table table-bordered table-striped table-hover dt-ext mobile-friendly-table">
            <thead>
              <tr>
                <th style="min-width: 50px;">#</th>
                <th style="min-width: 130px;">Fecha</th>
                <th style="min-width: 150px;">Facturas pendientes</th>
                <th style="min-width: 130px;">Saldo</th>
                <th style="min-width: 120px;">Acción</th>
              </tr>
            </thead>
            <tbody>
              @for (r of resumen; track r.fecha; let i = $index) {
                <tr>
                  <td [attr.data-label]="'#'">{{ i + 1 }}</td>
                  <td [attr.data-label]="'Fecha'">
                    <a href="javascript:;" class="fw-bold text-primary" (click)="abrirDetalle(r.fecha)">
                      <i class="fe fe-calendar me-1"></i>{{ formatFechaCorta(r.fecha) }}
                    </a>
                  </td>
                  <td [attr.data-label]="'Facturas pendientes'"><span class="badge bg-warning">{{ r.total }}</span></td>
                  <td [attr.data-label]="'Saldo'"><strong>$ {{ r.saldo | number: '1.2-2' }}</strong></td>
                  <td [attr.data-label]="'Acción'">
                    <button class="btn btn-sm btn-outline-primary w-100" (click)="abrirDetalle(r.fecha)">
                      <i class="fe fe-eye me-1"></i> Ver / Enviar
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Detalle de pendientes por fecha -->
<ng-template #detalleModal let-modal="modal">
  <div class="modal-header">
    <h5 class="modal-title">
      Facturas pendientes &mdash; {{ formatFechaCorta(fechaSeleccionada) }}
    </h5>
    <button type="button" class="close" aria-label="Cerrar"
            (click)="detalleModalRef?.dismiss()" [disabled]="procesando">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <!-- Barra de progreso -->
    <div class="mb-3" *ngIf="procesando || procesados > 0">
      <div class="d-flex justify-content-between mb-1">
        <span class="fw-bold">{{ porcentaje }}%</span>
        <span class="text-muted">{{ procesados }}/{{ total }}</span>
      </div>
      <div class="progress" style="height: 18px;">
        <div class="progress-bar progress-bar-striped progress-bar-animated"
             [class.bg-primary]="procesando"
             [class.bg-success]="!procesando && fallidos === 0"
             [class.bg-warning]="!procesando && fallidos > 0"
             role="progressbar" [style.width.%]="porcentaje">
        </div>
      </div>
      <div class="mt-2">
        <span class="badge bg-success me-2">Enviados: {{ exitosos }}</span>
        <span class="badge bg-danger">Con error: {{ fallidos }}</span>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-bordered table-striped table-hover mobile-friendly-table mb-0">
        <thead>
          <tr>
            <th style="min-width: 40px;">#</th>
            <th style="min-width: 120px;">Secuencial</th>
            <th style="min-width: 140px;">Beneficiario</th>
            <th style="min-width: 90px;">N° Orden</th>
            <th style="min-width: 90px;">Total</th>
            <th style="min-width: 130px;">Fecha</th>
            <th style="min-width: 110px;">Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="cargandoDetalle">
            <td colspan="7" class="text-center text-muted py-3">Cargando...</td>
          </tr>
          <tr *ngIf="!cargandoDetalle && detalle.length === 0">
            <td colspan="7" class="text-center text-muted py-3">No hay documentos pendientes en esta fecha</td>
          </tr>
          @for (d of detalle; track d.COD_TRAC; let i = $index) {
            <tr>
              <td [attr.data-label]="'#'">{{ i + 1 }}</td>
              <td [attr.data-label]="'Secuencial'"><span class="badge bg-primary">{{ d.NUM_TRAC || d.NUM_TRACFIC }}</span></td>
              <td [attr.data-label]="'Beneficiario'">{{ d.nombre_cliente?.trim() ? d.nombre_cliente : d.NOM_CLI }}</td>
              <td [attr.data-label]="'N° Orden'">{{ d.ordenFactura === 'multiple' ? 'PAQUETE' : d.ordenFactura }}</td>
              <td [attr.data-label]="'Total'"><strong>$ {{ d.TOTPAG_TRAC | number: '1.2-2' }}</strong></td>
              <td [attr.data-label]="'Fecha'">{{ formatFecha(d.FEC_TRAC) }}</td>
              <td [attr.data-label]="'Estado'">
                <span *ngIf="!d._resultado" class="badge bg-warning">Pendiente</span>
                <span *ngIf="d._resultado === 'ok'" class="badge bg-success" [title]="d._mensaje">Enviado</span>
                <span *ngIf="d._resultado === 'error'" class="badge bg-danger" [title]="d._mensaje">Error</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="detalleModalRef?.dismiss()" [disabled]="procesando">
      Cerrar
    </button>
    <button type="button" class="btn btn-primary" (click)="procesar()"
            [disabled]="procesando || cargandoDetalle || detalle.length === 0">
      <i class="fe fe-send me-1"></i> {{ procesando ? 'Procesando...' : 'Enviar al SRI' }}
    </button>
  </div>
</ng-template>
